import { apiStoreLenses } from 'root/src/client/logic/api/lenses'
import modulesObj from 'root/src/shared/descriptions/modules'
import map from 'ramda/src/map'
import __ from 'ramda/src/__'
import pathOr from 'ramda/src/pathOr'
import path from 'ramda/src/path'
import mergeAll from 'ramda/src/mergeAll'
import createRecordClickActionStoreKey from 'root/src/client/logic/api/util/createRecordClickActionStoreKey'
import { omitNil } from 'root/src/shared/util/ramdaPlus'
import currentRouteParams from 'root/src/client/logic/route/selectors/currentRouteParams'

const { viewRecordClickActionErrorsChild } = apiStoreLenses

export default (state, { moduleId }) => {
	const recordClickActions = pathOr([], [moduleId, 'recordClickActions'], modulesObj)
	const routeParams = currentRouteParams(state, { moduleId })
	const recordId = path(['recordId'], routeParams)
	const recordClickActionStoreKeys = map(recordClickActionId => createRecordClickActionStoreKey(
		recordClickActionId, recordId,
	), recordClickActions)
	return mergeAll(
		omitNil(map(viewRecordClickActionErrorsChild(__, state), recordClickActionStoreKeys)),
	)
}
